import styles from "./LastRequestsEmpty.module.scss";

export const LastRequestsEmpty = () => {
  return (
    <div className={styles.empty}>
      <p className={styles.title}>Запросы отсутствуют</p>
    </div>
  );
};
